import { CModelRepo as cModelRepo } from '../cmodel.repo';
class newCModelDialog{
  /** @ngInject */
  constructor(private cModelRepo: cModelRepo,private $state: angular.ui.IStateService,private $mdDialog: angular.material.IDialogService) {
  }

  createCModel(){
    this.$mdDialog.hide();
    }
   cancel() {
    this.$mdDialog.cancel();
  }
}

export const cModelDialog: angular.IComponentOptions = {
  template: require('./cmodel.dialog.html'),
  controller: newCModelDialog
}



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.mauritius/cmodel.dialog.ts